import { createFileRoute } from '@tanstack/react-router';
import TestDetailPage from '@/pages/(protected)/workspaces/[workspaceId]/compliance/tests/[testId]';

type TestDetailSearch = {
  from?: 'tasks' | 'tests';
  frameworkId?: string;
  frameworkName?: string;
  tab?: string;
};

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/compliance/tests/$testId'
)({
  component: TestDetailPage,
  validateSearch: (search: Record<string, unknown>): TestDetailSearch => {
    return {
      from: search.from as TestDetailSearch['from'],
      frameworkId: search.frameworkId as string | undefined,
      frameworkName: search.frameworkName as string | undefined,
      tab: search.tab as string | undefined,
    };
  },
});
